import styled from "styled-components";

export const VideoSlideBox = styled.div`
    height: 100%;
    width: 100%;
    font-weight: bold;
    font-size: 32px;
    background-color: green;
    color: white;
`

